module.exports = __webpack_public_path__ + "img/icon_blocked_selected.10f4e47f.svg";